import type { FC } from 'react';
import {
  HeroSection,
  StatsSection,
  CapabilitiesSection,
  PlatformSection,
  BoundarySection,
  BottomCtaSection,
} from '@/sections';
import { HorizontalPager } from '@/components/layout/HorizontalPager';

/**
 * Home Page — 6 屏架构（StoryBrand 模式）
 * Screen 1: Hero（梦想 + 价值主张 + 双 CTA）
 * Screen 2: Stats（数字说话 ROI）
 * Screen 3: Capabilities（7 大能力矩阵）
 * Screen 4: Platform（协同动画 全屏）
 * Screen 5: Boundary（信任层承诺 + 合规）
 * Screen 6: BottomCta（最后联系 + 登录）
 */
const Home: FC = () => {
  return (
    <main>
      <HorizontalPager>
        <HeroSection />
        <StatsSection />
        <CapabilitiesSection />
        <PlatformSection />
        <BoundarySection />
        <BottomCtaSection />
      </HorizontalPager>
    </main>
  );
};

export default Home;
